import React from "react";
import { useNavigate } from "react-router-dom";
import "./Home.css";

const translations = {
  en: {
    title:
      "UK driving theory test made simple for millions of non-native English speaking learner drivers.",
    subtitle:
      "Our learners pass first time, and we can help you too. Jump straight into practice.",
    startButton: "Start practice",
    slides: [
      {
        title: "Practice Tests",
        description: "Access hundreds of practice questions and mock tests",
      },
      {
        title: "Welcome to BDTT",
        description: "Your Complete driving test preparation companion",
      },
      {
        title: "Track Progress",
        description:
          "Monitor your performance and identify areas for improvement",
      },
    ],
  },
  bn: {
    title:
      "লাখো ইংরেজিতে অনভিজ্ঞ শিক্ষার্থীদের জন্য ইউকে ড্রাইভিং থিওরি টেস্ট সহজ করা হয়েছে।",
    subtitle:
      "আমাদের শিক্ষার্থীরা প্রথমবারেই পাস করে, আপনিও পারবেন। অনুশীলন শুরু করুন।",
    startButton: "অনুশীলন শুরু করুন",
    slides: [
      {
        title: "অনুশীলন পরীক্ষা",
        description: "শত শত অনুশীলন প্রশ্ন ও মক টেস্টে প্রবেশ করুন",
      },
      {
        title: "BDTT এ স্বাগতম",
        description: "আপনার সম্পূর্ণ ড্রাইভিং টেস্ট প্রস্তুতির সঙ্গী",
      },
      {
        title: "অগ্রগতি ট্র্যাক করুন",
        description:
          "আপনার পারফরম্যান্স নিরীক্ষণ করুন এবং উন্নয়নের ক্ষেত্র নির্ধারণ করুন",
      },
    ],
  },
};

function Home() {
  const navigate = useNavigate();
  const lang = localStorage.getItem("lang") === "bn" ? "bn" : "en";
  const t = translations[lang];

  return (
    <div className={`home ${lang === "bn" ? "bn-font" : ""}`}>
      <p className="home-title">{t.title}</p>
      <p className="home-title-small">{t.subtitle}</p>
      <button onClick={() => navigate("/login")} className="home-start-button">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="lucide lucide-list-todo w-5 h-5 mr-2"
        >
          <rect x="3" y="5" width="6" height="6" rx="1"></rect>
          <path d="m3 17 2 2 4-4"></path>
          <path d="M13 6h8"></path>
          <path d="M13 12h8"></path>
          <path d="M13 18h8"></path>
        </svg>
        <span>{t.startButton}</span>
      </button>
      <div className="pricing-comparison">
        <div className="comparison-title">Upgrade to Premium and Enjoy:</div>
        <table className="comparison-table">
          <thead>
            <tr>
              <th>Feature</th>
              <th>Free</th>
              <th>Premium</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Full access to all DVSA ADI practice questions</td>
              <td>2 Categories</td>
              <td>All</td>
            </tr>
            <tr>
              <td>Access to unlimited mock tests</td>
              <td>❌</td>
              <td>✅</td>
            </tr>
            <tr>
              <td>Access to hazard perception videos</td>
              <td>❌</td>
              <td>✅</td>
            </tr>
            <tr>
              <td>Access to all case study questions</td>
              <td>❌</td>
              <td>✅</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="home-slide-container">
        {t.slides.map((slide, index) => (
          <div key={index} className="home-slide">
            <img
              className="home-slide-img"
              src={`/Assets/Logos/intro${index + 1}.png`}
              alt={slide.title}
            />
            <p className="home-slide-title-1">{slide.title}</p>
            <p className="home-slide-title-2">{slide.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Home;
